import { Stack, Typography } from '@mui/material';
import { SearchAllTransactionsSearchBox } from './SearchAllTransactionsSearchBox';

export const SearchAllTransactionsContainer = () => {
  return (
    <Stack
      spacing={1}
      sx={{ flexGrow: 1, maxWidth: { xs: 'unset', md: '60%' } }}
    >
      <Typography variant="h2" sx={{ color: 'other.spaceCadet' }}>
        Search Transactions
      </Typography>
      <Typography sx={{ pb: 1.5 }}>
        Quickly access any of your transactions
      </Typography>
      <SearchAllTransactionsSearchBox />
    </Stack>
  );
};
